module.exports = __webpack_public_path__ + "static/cotas-abarcones-serie-pesada-bb3d62e3fce9fe698f3ad2002de76916.pdf";